

import menu from '@/modules/app/menu/store';
import usuarios from '@/modules/app/usuarios/store';
import menus from '@/modules/app/menus/store';
import rotas from '@/modules/app/rotas/store';
import modulos from '@/modules/app/modulos/store';
import grupos from '@/modules/app/grupos/store';
import gruposRotas from '@/modules/app/grupo-rotas/store';
import submodulos from '@/modules/app/submodulos/store';
import usuariosPerfis from '@/modules/app/usuarios-perfis/store';
import perfisMenus from '@/modules/app/perfis-menus/store';
import perfisRotas from '@/modules/app/perfis-rotas/store';
import perfisUsuarios from '@/modules/app/perfis-usuarios/store';
import perfis from '@/modules/app/perfis/store';
import vueComponentesMenus from '@/modules/app/vue-componentes-menus/store';
import usuariosApis from '@/modules/app/usuarios-apis/store';
import aclAutenticacoes from '@/modules/app/acl-autenticacoes/store';
import ctrlEquipes from '@/modules/app/ctrl-equipes/store';
import ctrlModulos from '@/modules/app/ctrl-modulos/store';
const store = {
  menu,
  usuarios,
  menus,
  rotas,
  modulos,
  grupos,
  gruposRotas,
  submodulos,
  usuariosPerfis,
  perfisMenus,
  perfisRotas,
  perfisUsuarios,
  perfis,
  vueComponentesMenus,
  usuariosApis,
  aclAutenticacoes,
  appCtrlEquipes: ctrlEquipes,
  ctrlModulos
}

export default store